'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _fetchJsonp = require('fetch-jsonp');

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function jsonpRequest(_ref) {
  var url = _ref.url,
      charset = _ref.charset,
      callbackParamName = _ref.callbackParamName;

  return (0, _fetchJsonp2.default)(url, {
    jsonpCallback: callbackParamName // optional, 'callback' by default
  }).then(function (res) {
    return res.json();
  }).catch(function (err) {
    console.log('[jsonpRequest] catch Error: ' + url, false, 400, 'Sys Error', 'errors: ' + (0, _stringify2.default)(err));
  });
}

exports.default = jsonpRequest;
module.exports = exports['default'];